import { GroupType } from '../../entities/groups';
import { ClaimLimitPeriod, IncentiveState, IncentiveVisibility } from '../../entities/incentives';
import { User } from '../../entities/users';

export enum ClaimLimitMode {
	Unlimited = 'unlimited',
	PerEmployee = 'perEmployee',
	PerPeriod = 'perPeriod',
}

export type IncentiveFormData = {
	name: string;
	icon: File | string | null;
	description: string;
	requireProof: boolean;
	conditionsOperator: GroupType;
	conditions: { attr: string | undefined; value: string | undefined }[];
	claimLimitMode: ClaimLimitMode;
	claimLimitQuantity: number | null;
	periodType: ClaimLimitPeriod;
	userClaimLimit: null | number;
	amount: number;
	message: string;
	visibility: IncentiveVisibility;
	requireApproval: boolean;
	approvalLevels: User[][];
	state: IncentiveState;
};
